import http from "../../../services/httpService";

const apiEndpoint = "/api/mess-fee-details";

function create(data) {
  return http.post(apiEndpoint, data);
}

function update(data,id) {
  return http.patch(`${apiEndpoint}/${id}`, data);
}

function get(id) {
  return http.get(`${apiEndpoint}/${id}`);
}
function getMessFeeByNumOfMeals(hostelId,numOfMeals) {
  return http.get(`${apiEndpoint}/num-of-meals`,{params:{hostelId,numOfMeals}});
}

function getAll() {
  return http.get(apiEndpoint);
}
function getAllByQuery(query) {
  return http.get(`${apiEndpoint}/q`,{params:query});
}

function getAllList() {
  return http.get(apiEndpoint + "/list");
}


function deleteById(id) {
  return http.delete(`${apiEndpoint}/${id}`);
}

export default {
  create,
  update,
  get,
  getMessFeeByNumOfMeals,
  getAll,
  getAllByQuery,
  getAllList,
  deleteById,
};
